<template>
  <div class="certification_details">
    <div class="tit">
      <span>
        <router-link
          to="/personal_center/park_user/meeting_room_reservation/meeting_room_record"
          class="back"
        >
          <i class="el-icon-arrow-left"></i>
        </router-link>会议室预定详情
      </span>
    </div>
    <div class="body_content">
      <el-row v-if="detail">
        <el-col :span="24">
          <div class="detail_l">所属园区：</div>
          <div class="detail_r">{{detail.incubator_name}}</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">会议室名称：</div>
          <div class="detail_r">{{detail.meeting_name}}</div>
        </el-col>
        <!-- <el-col :span="24">
          <div class="detail_l">会议室主题：</div>
          <div class="detail_r">{{detail.name}}</div>
        </el-col> -->
        <el-col :span="24">
          <div class="detail_l">预定人：</div>
          <div class="detail_r">{{detail.contact}}</div>
        </el-col>
        <!-- <el-col :span="24">
          <div class="detail_l">所属部门：</div>
          <div class="detail_r">{{detail.department}}</div>
        </el-col> -->
        <el-col :span="24">
          <div class="detail_l">联系电话：</div>
          <div class="detail_r">{{detail.contact_phone}}</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">提交时间：</div>
          <div class="detail_r">{{detail.create_date}}</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">预定日期：</div>
          <div class="detail_r">{{detail.use_date}}</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">预定时间段：</div>
          <div class="detail_r" v-if="detail.time">{{detail.time.startTime}}-{{detail.time.endTime}}</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">申请状态：</div>
          <div class="detail_r">{{detail.status_name}}</div>
        </el-col>
        <el-col :span="24">
          <div class="detail_l">预计费用：</div>
          <div class="detail_r">{{detail.total_money}}元</div>
        </el-col>
         <el-col :span="24" v-if="detail.status==='IdentityCertifieStatusFailed'">
          <div class="detail_l">原因：</div>
          <div class="detail_r">{{detail.examine_remark}}</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {}
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  created() {
    if (this.$store.state.info) {
      this.getList(); /** 查询认证 用于二次编辑*/
    } else {
      this.needInfo("getList");
    }
  },
  methods: {
    /* 监测Props */
    needInfo(name) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[name]();
          watchAch(); //取消监听
        }
      });
    },
    /* 获取列表数据 */
    getList() {
      let obj = {
        id: this.$route.query.id,
        user:this.info.userId
      };
      this.api.getFontMeetingOrders(obj).then(res => {
        if (res.error.err_code != 0) return;
        let list = res.obj.list || [];
        let obj = list.length ? res.obj.list[0] : {};
        this.detail = Object.assign({}, this.detail, obj);
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.certification_details {
    line-height: 41px;
  .tit {
    .back {
      display: inline-block;
      width: 38px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border: 1px solid #dcdfe6;
      margin-right: 14px;
      cursor: pointer;
      vertical-align:middle;;
    }
  }
  .el-col{
    display: flex;
    font-size: 14px;
  }
  .detail_l {
    color: #999;
  }
  .detail_r {
  }
}
</style>
